
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eigentuemer/immobilie-verkaufen",
      function () {
        return require("private-next-pages/eigentuemer/immobilie-verkaufen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eigentuemer/immobilie-verkaufen"])
      });
    }
  